export default function () {
    return {
        KEYS: {
            COURSE: 'course',
            COURSE_TRAINING: 'course_training'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/file/entityType/index.js